import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=0c99b154&scoped=true"
import script from "./Certificates.vue?vue&type=script&setup=true&lang=js"
export * from "./Certificates.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=0c99b154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99b154",
  null
  
)

export default component.exports